import { call, put, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/reason";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import * as types from "./types";
import * as actions from "./actions";

function* getReasonListSaga({ payload }) {
  try {
    const response = yield call(apis.getReason, payload);
    yield put(
      actions.getReasonResponse({
        reasons: response.data?.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getReasonRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* getSingleReasonListSaga({ payload }) {
  try {
    const response = yield call(apis.getSingleReason, payload);
    yield put(actions.getSingleReasonResponse(response.data?.data));
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* updateReasonListSaga({ payload }) {
  try {
    const response = yield call(apis.updateReason, payload);
    yield put(actions.updateReasonResponse(response.data.data));
    yield put(actions.getReasonRequest());
    yield showSuccessMsg("Reason Updated Sucessfully!", true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

export default function* ReasonSagas() {
  yield takeEvery(types.GET_REASON_REQUEST, getReasonListSaga);
  yield takeEvery(types.GET_SINGLE_REASON_REQUEST, getSingleReasonListSaga);
  yield takeEvery(types.UPDATE_REASON_REQUEST, updateReasonListSaga);
}
